// Components
import { UserForm } from "./UserForm";

const AddUser = () => {
  return <UserForm edit={false} />;
};

export { AddUser };
